import {
  connectFirestoreEmulator,
  initializeFirestore,
} from 'firebase/firestore';
import firebase from 'firebase/compat/app';
import { getAuth, connectAuthEmulator, Auth } from 'firebase/auth';
import {
  getFunctions,
  connectFunctionsEmulator,
  Functions,
} from 'firebase/functions';
import 'firebase/compat/functions';
import 'firebase/compat/storage';

export const isUsingEmulators =
  process.env.NODE_ENV === 'development' &&
  import.meta.env.VITE_APP_USE_FIREBASE_EMULATORS == 'true';

const firebaseConfig = {
  apiKey: 'AIzaSyDG_Xdlt6gyYdR_lH66_K8zaqrI_e574ko',
  authDomain: 'breakfast-8ac2d.firebaseapp.com',
  projectId: 'breakfast-8ac2d',
  storageBucket: 'breakfast-8ac2d.appspot.com',
  messagingSenderId: '423798668073',
  appId: '1:423798668073:web:816d57444ced42a2ae1538',
  measurementId: 'G-66059JGPQV',
};

const app = firebase.initializeApp(firebaseConfig);

const db = initializeFirestore(app, {
  ignoreUndefinedProperties: true,
});

const auth: Auth = getAuth(app);

const functions: firebase.functions.Functions = firebase.functions();
const functionsV9: Functions = getFunctions(app, 'us-central1');

const storage: firebase.storage.Storage = firebase.storage();

if (isUsingEmulators) {
  const host = import.meta.env.VITE_APP_FIREBASE_EMULATOR_HOST ?? '127.0.0.1';
  const authPort =
    import.meta.env.VITE_APP_FIREBASE_AUTH_EMULATOR_PORT ?? '9099';
  const firestorePort =
    import.meta.env.VITE_APP_FIREBASE_FIRESTORE_EMULATOR_PORT ?? '8080';
  const storagePort =
    import.meta.env.VITE_APP_FIREBASE_STORAGE_EMULATOR_PORT ?? '9199';
  const functionsPort =
    import.meta.env.VITE_APP_FIREBASE_FUNCTIONS_EMULATOR_PORT ?? '5001';
  console.info(`Practist is using Firebase emulators`);
  console.log(`Auth emulator: http://${host}:${authPort}`);
  console.log(`Firestore emulator: http://${host}:${firestorePort}`);
  console.log(`Storage emulator: http://${host}:${storagePort}`);
  console.log(`Functions emulator: http://${host}:${functionsPort}`);

  connectAuthEmulator(auth, `http://${host}:${authPort}`);
  connectFirestoreEmulator(db, host, parseInt(firestorePort, 10));
  storage.useEmulator(host, parseInt(storagePort, 10));
  functions.useEmulator(host, parseInt(functionsPort, 10));
  connectFunctionsEmulator(functionsV9, host, parseInt(functionsPort, 10));
}

export { firebase, app, db, auth, functions, functionsV9, storage };
